module.exports = __webpack_public_path__ + "img/antes_despues_321.0b762571.png";